import React, { useState, useRef } from "react";
import "./HorizontalSlider.css";
import ResultsTable from "./ResultsTable";

const HorizontalSlider = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef(null);

  const scrollToIndex = (index) => {
    setActiveIndex(index);
    const slider = sliderRef.current;
    if (slider) {
      const itemWidth = slider.clientWidth / items.length; // Get dynamic item width
      slider.scrollTo({ left: index * itemWidth, behavior: "smooth" });
    }
  };

  return (
    <div className="horizontal-tabs-container">
      {/* Tabs Scrollable Slider */}
      <div className="tabs-slider" ref={sliderRef}>
        {items.map((item, index) => (
          <div
            key={index}
            className={`tab-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => scrollToIndex(index)}
          >
            {item}
          </div>
        ))}
      </div>

      {/* Content Below the Tabs */}
      <div className="tab-content">
        {/* <h3 className="tab-title">{items[activeIndex]}</h3> */}
        <ResultsTable result={`Adventure_${items[activeIndex]}`} />
        <ResultsTable result={`Trophy_${items[activeIndex]}`} />
      </div>
    </div>
  );
};

export default HorizontalSlider;
